import React, {useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import {Empty, Spin} from 'antd';
import Line from '@ant-design/charts/es/line';
import {chartStatistic} from '@/api/customer';

const CountLineChart = forwardRef(({searchParams}, ref) => {
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        init(searchParams);
    }, []);

    useImperativeHandle(ref, () => ({
        reload,
    }));

    function init(params) {
        console.log('params', params);
        const {startTime, endTime, userId} = params;
        setLoading(true);
        chartStatistic({startTime, endTime, userId}).then(res => {
            setChartData(res.data);
            setLoading(false);
            // console.log('......', res.data);
        });
    }

    function reload(reloadParams) {
        init(reloadParams);
    }

    function renderCharts() {
        let data = [];
        let config = {
            xField: 'statTime',
            yField: 'value',
            seriesField: 'name',
            isGroup: 'true',
            color: ['#152D85', '#03C5EC'],
            point: {
                size: 4,
                shape: 'radio',
                // color: ['#152D85', '#03C5EC'],
            },
        };
        chartData.forEach(item => {
            const {insCount, totalCount, time} = item;
            data.push({
                name: '日新增人数',
                value: insCount,
                statTime: time,
            });
            data.push({
                name: '日总人数',
                value: totalCount,
                statTime: time,
            });
        });
        config.data = data;
        return data.length > 0 ? <Line {...config} /> : <Empty />;
    }

    return (
        <div style={{width: '100%'}}>
            <Spin spinning={loading}>{renderCharts()}</Spin>
        </div>
    );
});

CountLineChart.displayName = 'CountLineChart';

CountLineChart.propTypes = {
    searchParams: PropTypes.shape({
        startTime: PropTypes.number.required,
        endTime: PropTypes.number.required,
        userId: PropTypes.string.required,
    }),
};

export default CountLineChart;
